import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { ResourceIcon } from "../../generic/icon/ResourceIcon";
export var Recipe = function (_a) {
    var cost = _a.cost, product = _a.product, shouldDisplayInputIcon = _a.shouldDisplayInputIcon, onClick = _a.onClick, className = _a.className, unlockLevel = _a.unlockLevel, hideTooltip = _a.hideTooltip, isLocked = _a.isLocked;
    var resource = shouldDisplayInputIcon ? cost[0] : product[0];
    return (React.createElement("div", { onClick: onClick, className: (className || "") + " " + IdStyles.RecipeItem + " flex flex--guts" },
        React.createElement(ResourceIcon, { resource: resource, styleId: IdStyles.IconExtraLarge, unlockLevel: unlockLevel, hideTooltip: hideTooltip, isLocked: isLocked })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/inventory/recipe/Recipe.tsx
// module id = 877
// module chunks = 3